import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'hooks/use-translation';
import { Button, ButtonProps } from '../button';

interface Props {
  count?: number;
}

const FilterButtonActual = styled(Button)<Required<Props>>`
  border-color: var(--primary-color);
  &:hover {
    background-color: var(--primary-color);
    color: white;
  }
  ${({ count }) =>
    count > 0 &&
    css`
      background: var(--blue-10);
      color: var(--blue-70);
    `};
`;

export const FilterButton: FC<Props & ButtonProps> = (props) => {
  const { count: optional } = props;
  const count = optional || 0;

  return (
    <FilterButtonActual
      type="link"
      size="small"
      {...props}
      count={count}
      hideHoverBorderRadius
      hideHoverEffect
    >
      {useTranslation('captions.buttons.filter', { count })}
    </FilterButtonActual>
  );
};
